module.exports = __webpack_public_path__ + "img/m-b.75de8521.png";